// Subtle, asset-free delivery chime via the Web Audio API (a gentle rising two-note).
// Browsers start an AudioContext suspended until a user gesture — call primeChime() on the
// first interaction so interval-driven chimes can play.
let ctx;

function getCtx() {
  if (typeof window === "undefined") return null;
  if (!ctx) {
    const AC = window.AudioContext || window.webkitAudioContext;
    if (!AC) return null;
    ctx = new AC();
  }
  return ctx;
}

export function primeChime() {
  const c = getCtx();
  if (c && c.state === "suspended") c.resume().catch(() => {});
}

export function playChime() {
  const c = getCtx();
  if (!c) return;
  if (c.state === "suspended") c.resume().catch(() => {});
  const now = c.currentTime;
  [880, 1174.66].forEach((freq, i) => {
    const osc = c.createOscillator();
    const gain = c.createGain();
    osc.type = "sine";
    osc.frequency.value = freq;
    const t = now + i * 0.14;
    gain.gain.setValueAtTime(0.0001, t);
    gain.gain.exponentialRampToValueAtTime(0.14, t + 0.02);
    gain.gain.exponentialRampToValueAtTime(0.0001, t + 0.45);
    osc.connect(gain).connect(c.destination);
    osc.start(t);
    osc.stop(t + 0.5);
  });
}

export const CHIME_KEY = "phs_shipments_chime";
export const chimeEnabled = () => typeof window !== "undefined" && localStorage.getItem(CHIME_KEY) !== "off";
export const setChimeEnabled = (on) => localStorage.setItem(CHIME_KEY, on ? "on" : "off");
